export default function Banner() {
    return (
        <div className="bg-teal-200 p-10">
            <div className="flex flex-col justify-center items-center md:flex-row md:items-center md:space-x-16">
                <div className="flex flex-row space-x-8">
                    <img src={require("../assets/DuckSong.png")} className="h-28" alt="Duck Song Logo" />
                    <img src={require("../assets/Grapes.png")} className="h-28" alt="Grapes" />
                </div>
                
                <div className="font-PublicPixel text-4xl md:text-7xl text-center text-green-500">DUCK SONG</div>
            </div>
            <div className="flex justify-center font-PublicPixel text-sm md:text-lg text-center text-green-800">Got any $GRAPES?</div>
        </div>
    )
}

